/* unplugin-vue-components disabled */import { render } from "./companyLogo.vue?vue&type=template&id=1176f0dd&scoped=true"
import script from "./companyLogo.vue?vue&type=script&lang=js"
export * from "./companyLogo.vue?vue&type=script&lang=js"

import "./companyLogo.vue?vue&type=style&index=0&id=1176f0dd&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1176f0dd"]])

export default __exports__